/**
 * AwardSpotlight
 * -----------------------------------------------------------------------
 * Editorial "certificate spread" treatment for the Premio Cambiamenti
 * recognition: one dominant event photo with a smaller inset photo
 * tucked over its corner (like two prints laid on a desk), a bespoke
 * seal glyph instead of a stock trophy icon, and a divided credential
 * strip instead of boxed cards.
 *
 * Props:
 *   awards — the `t('awards', lang)` object from translations.js
 *            (badge, title, subtitle, desc, desc2,
 *             card1Title, card1Sub, card2Title, card2Sub,
 *             img1Alt, img2Alt)
 */
const AwardSpotlight = ({ awards }) => (
  <section id="awards" className="section award-spotlight">
    <div className="section-inner award-spotlight-inner">
      <div className="award-spotlight-grid">

        {/* ── Photo stack ── */}
        <div className="award-spotlight-visual animate-on-scroll">
          <div className="award-photo-main">
            <img
              src={`${process.env.PUBLIC_URL}/premio-cambiamenti-1.jpg`}
              alt={awards.img1Alt}
            />
          </div>
          <div className="award-photo-inset">
            <img
              src={`${process.env.PUBLIC_URL}/premio-cambiamenti-2.jpg`}
              alt={awards.img2Alt}
            />
          </div>
        </div>

        {/* ── Content ── */}
        <div className="award-spotlight-content animate-on-scroll animate-delay-2">
          <div className="section-label award-eyebrow">
            <SealMark />
            {awards.badge}
          </div>

          <h2 className="section-title award-title">
            {awards.title}
            <br />
            <span className="hero-title-accent">{awards.subtitle}</span>
          </h2>

          <p className="award-desc">{awards.desc}</p>
          <p className="award-desc">{awards.desc2}</p>

          <div className="award-credentials">
            <div className="award-credential">
              <span className="award-credential-value">{awards.card1Title}</span>
              <span className="award-credential-label">{awards.card1Sub}</span>
            </div>
            <div className="award-credential-divider" aria-hidden="true" />
            <div className="award-credential">
              <span className="award-credential-value">{awards.card2Title}</span>
              <span className="award-credential-label">{awards.card2Sub}</span>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>
);

/* Bespoke seal glyph — drawn to match the stroke weight of the
   lucide-react icon set used everywhere else on the site, so it
   reads as part of the same icon family rather than a foreign asset. */
const SealMark = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="award-seal-mark"
    aria-hidden="true"
  >
    <circle cx="12" cy="9" r="6.25" />
    <circle cx="12" cy="9" r="3.1" />
    <path d="M8.7 14.2 7 21l5-2.4 5 2.4-1.7-6.8" />
  </svg>
);

export default AwardSpotlight;
